export default function PageHeader({ overline, title, subtitle, action }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div>
        {overline && (
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#8A8F98] mb-3 font-medium">
            {overline}
          </p>
        )}
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight leading-none text-[#0A1128]">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[#5C616A] mt-3 max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
      {action}
    </div>
  );
}
